// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-b2392200] {\n  background-color: #9EABED;\n  border-radius: 4px;\n}\n.disabled[data-v-b2392200]:hover {\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
